module.exports = __webpack_public_path__ + "img/light3.e0892426.png";